import type { ComponentProps } from "react";

import { cn } from "shared/utils/cn";

type Props = { text: string };

export const Label = ({
  children,
  className,
  text = "",
  ...props
}: ComponentProps<"label"> & Props) => {
  return (
    <label
      {...props}
      className={cn(
        "inline-flex flex-col leading-5.5 tracking-[0.4px]",
        className
      )}
    >
      <span className="mb-2">{text}</span>
      {children}
    </label>
  );
};
